import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NewIcon from '@mui/icons-material/Add';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';
import TitledSection from '../../common/TitledSection/TitledSection';
import CVBaseItem from '../../common/CVBaseItem/CVBaseItem';
import classes from './scss/historyListPB.module.scss';
import { cvUpdate } from '../../../actions/uploadData';
import ValidationErrorLabel from '../../common/ValidationErrorLabel/ValidationErrorLabel';
import AddEditCVRecord from '../../common/ModalWindows/AddEditCVRecord';

function TrainingsAndCertificatesPB(props) {
  const { forErrors = false } = props;

  const dispatch = useDispatch();
  const [t] = useTranslation();
  const trainingsItems = useSelector((state) =>
    !forErrors ? state.uploadData.parsedCV.TrainingDetails : state.uploadData.validationErrors.JobExperienceDetails
  );
  const errors = useSelector((state) => state.uploadData.validationErrors.TrainingDetails);

  const [openAddWindow, setAddWindow] = React.useState(false);

  const deleteHandler = (id) => {
    dispatch(cvUpdate({ flag: 'TrainingDelete', value: id }));
  };

  const addTraining = async (training) => {
    dispatch(
      cvUpdate({
        flag: 'TrainingAdd',
        value: {
          id: uuidv4(),
          CertificationType: training.type,
          CertificationId: training.certId,
          ValidUntil: training.valid || null,
          StartDate: new Date(),
          EndDate: new Date()
        }
      })
    );
    setAddWindow(false);
  };

  const updateTraining = async (id, training) => {
    dispatch(
      cvUpdate({
        flag: 'TrainingUpdate',
        value: {
          id,
          CertificationType: training.type,
          CertificationId: training.certId,
          ValidUntil: training.valid,
          StartDate: new Date(),
          EndDate: new Date()
        }
      })
    );
  };

  return (
    <TitledSection
      title={t('profile.builder.details.training')}
      actions={<NewIcon role="button" className={classes.action} onClick={() => setAddWindow(true)} />}
    >
      <hr className={classes.divider} />
      <div className={classes.list}>
        {openAddWindow && (
          <AddEditCVRecord
            open
            closeHandler={() => setAddWindow(false)}
            editeMode={false}
            confirmHandler={addTraining}
            block="trainings"
            shouldImmediatelySave
          />
        )}
        {trainingsItems?.map((item) => (
          <Fragment key={item.id}>
            <CVBaseItem
              key={item?.id || new Date()}
              item={item}
              block="trainings"
              deleteItem={() => deleteHandler(item?.id)}
              editItem={(data) => updateTraining(item?.id, data)}
              shouldImmediatelySave
            />
          </Fragment>
        ))}
      </div>
    </TitledSection>
  );
}

export default TrainingsAndCertificatesPB;
